module.exports = __webpack_public_path__ + "media/Teil 5.1e6bc31f.webm";